module.exports = {"152922103":"巴丹吉林镇","152922104":"雅布赖镇","152922105":"阿拉腾敖包镇","152922211":"曼德拉苏木","152922212":"阿拉腾朝格苏木","152922213":"巴彦高勒苏木","152922214":"塔木素布拉格苏木"}


//////////////////
// WEBPACK FOOTER
// ./src/town/152922.json
// module id = 585
// module chunks = 0